import React from 'react';
import { Route, Switch } from 'react-router-dom';

import { PrivateRoute } from '../../../utils/route-auth';
import { PERMISSION } from '../../../constants/permission';

import asyncRoute from '../../../helpers/hoc/asyncRoute';
import routes from '../../../routes';

const List = asyncRoute(() => import('./List'));
const Add = asyncRoute(() => import('./Add'));

const User = (props) => (
  <Switch>
    <Route exact path={`${props.match.path}`} render={() => <List />} />
    {/* <Route path={`${props.match.path}/${routes.admin.user.add}`} component={Add} />
    <Route path={`${props.match.path}/${routes.admin.user.edit}/:id`} component={Add} /> */}

    <PrivateRoute path={`${props.match.path}/${routes.admin.user.add}`} component={Add}
      permissions={[PERMISSION.ADMIN.USERS.ADD]}
      defaultRoute={'admin'} />
    <PrivateRoute path={`${props.match.path}/${routes.admin.user.edit}/:id`} component={Add}
      permissions={[PERMISSION.ADMIN.USERS.EDIT]}
      defaultRoute={'admin'} />
  </Switch>
);

export default User;
